import Draggable from "react-draggable";
import { useRef, useContext } from "react";
import classNames from "classnames";
import "./share-indication.scss";
import { Participant } from "../../index-types";
import { ZoomMediaContext } from "../../../ZoomMediaProvider";
interface ShareIndicationBarProps {
  sharUserList: Array<Participant> | undefined;
  activeSharingId: number;
  isControllingUser?: boolean;
  viewType: string;
  setViewType: (viewtype: string) => void;
}
const ShareIndicationBar = (props: ShareIndicationBarProps) => {
  const { sharUserList, activeSharingId, isControllingUser } = props;
  const draggableRef = useRef(null);
  const mediaContext = useContext(ZoomMediaContext);

  if (!mediaContext) {
    throw new Error("ZoomMediaContext is not available. ");
  }

  const activeUser = (sharUserList ?? []).find(
    (user) => user.userId === activeSharingId
  );

  return (
    <Draggable nodeRef={draggableRef} axis="x" bounds="parent">
      <div className="share-indication-bar" ref={draggableRef}>
        <p
          className={classNames("share-indication-tip", {
            "share-indication-in-control": isControllingUser,
          })}
        >
          {`You are ${isControllingUser ? "controlling" : "viewing"} ${
            activeUser?.displayName
          }'s screen`}
        </p>
      </div>
    </Draggable>
  );
};

export default ShareIndicationBar;
